<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Cascading Scheme" subTitle="Forms" />

    <CreateCascadingScheme />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateCascadingScheme from "@/components/Pages/Management/CascadingScheme/CreateCascadingScheme.vue";

export default defineComponent({
  name: "CreateCascadingSchemePage",
  components: {
    PageTitle,
    CreateCascadingScheme,
  },
});
</script>
